import { createSlice } from "@reduxjs/toolkit";
import { proposalEligibilityStatus } from "../modules/researchAuthorities/Constants";
import { proposalSelector } from "./proposalSlice";

const initialState = {
  as: null,
  submitStatus: {},
  isLeader: false,
  applicant: null,
  termAgreed: false,
  budgetCodes: null,
};

const userSlice = createSlice({
  name: "applicants",
  initialState,
  reducers: {
    resetStore: (state) => {
      state = undefined;
    },
    setTermsAgreed: (state, { payload }) => {
      state.termAgreed = payload;
    },
    setAs: (state, { payload }) => {
      state.as = payload;
    },
    setApplicant: (state, { payload }) => {
      if (!Boolean(payload)) {
        state.applicant = null;
        return;
      }
      const { proposalName, name, proposalfullnumber, id,institutionId } = payload;
      state.applicant = {
        institutionId,
        proposalName,
        name,
        proposalId: proposalfullnumber,
        id,
      };
    },
    // },
    setSubmitStatus: (state, { payload }) => {
      const { generalInfo, financing, schedules, miscellaneous } = payload;
      state.submitStatus = { generalInfo, financing, schedules, miscellaneous };
    },
    setBudgetCodes: (state, { payload }) => {
      state.budgetCodes = payload;
    },
  },
  extraReducers: {},
});

const { actions, reducer } = userSlice;
export const {
  setAs,
  setSubmitStatus,
  setApplicant,
  resetStore,
  setTermsAgreed,
  setBudgetCodes,
} = actions;
export default reducer;

// selectors
export const reportingAsSelector = (state) => state.applicants.as;
export const applicantSelector = (state) => state.applicants.applicant;
export const submitStatusSelector = (state) => state.applicants.submitStatus;
export const budgetCodesSelector = (state) => state.applicants.budgetCodes;

export const isLeaderSelector = (state) => {
  const proposalLeader = proposalSelector(state)?.applicantLeaderId;
  const applicantId = applicantSelector(state)?.id;
  if (!proposalLeader) return false;
  if (!applicantId) return false;
  return applicantId === proposalLeader;
};

export const canEditSelector = (state) => {
  const proposal = proposalSelector(state);
  const applicant = applicantSelector(state);
  if (!applicant) return false;
  if (proposal) {
    if (
      proposal.eligibilitystatus === proposalEligibilityStatus.approvedByGIF ||
      proposal.eligibilitystatus === proposalEligibilityStatus.approvedByRA ||
      proposal.eligibilitystatus ===
        proposalEligibilityStatus.submittedByApplicationLeader ||
      proposal.eligibilitystatus ===
        proposalEligibilityStatus.submittedByResearchers ||
      proposal.eligibilitystatus === proposalEligibilityStatus.notEligible
    )
      return false;
  }
  const isLeader = isLeaderSelector(state);
  const as = reportingAsSelector(state);
  return isLeader || !as;
};
